import {
  VacanciesTemplatesBreadcrumbs,
  VacanciesTemplatesCreate,
} from '@features/vacanciesTemplates';
import { PageContainer } from '@shared/ui';
import { useEffect } from 'react';
import { useBreadcrumbs } from '@shared/lib';

export const VacanciesTemplatesCreatePage = () => {
  const context = useBreadcrumbs();

  useEffect(() => {
    if (!context) {
      return;
    }

    context.setBreadcrumb(
      <VacanciesTemplatesBreadcrumbs subPage='Новый шаблон' />
    );

    return () => {
      context.clearBreadcrumb();
    };
  }, []);

  return (
    <PageContainer title='Новый шаблон' py={{ base: 8, sm: 16 }} mx='0'>
      <VacanciesTemplatesCreate />
    </PageContainer>
  );
};
